import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from 'base-review-comments-library';
import { BaseReviewCommentsLibraryService } from 'base-review-comments-library';
import { first } from 'rxjs/internal/operators/first';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'authentication';
import * as i5 from 'dirty-check-store';
import * as i6 from '@angular/forms';
import * as i7 from '@angular/common';
import * as i8 from 'primeng/accordion';
import * as i9 from 'primeng/api';
import * as i10 from 'primeng/button';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';

class ReviewCommentsLibraryService {
    constructor() { }
}
ReviewCommentsLibraryService.ɵfac = function ReviewCommentsLibraryService_Factory(t) { return new (t || ReviewCommentsLibraryService)(); };
ReviewCommentsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ReviewCommentsLibraryService, factory: ReviewCommentsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewCommentsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["reviewCommentForm"];
function ReviewCommentsLibraryComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, "No comments");
    i0.ɵɵelementEnd();
} }
function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_2_ng_template_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "button", 24);
    i0.ɵɵlistener("click", function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_2_ng_template_2_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r18); const subItem_r11 = i0.ɵɵnextContext(2).$implicit; const item_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.handleSave(subItem_r11, item_r5); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r11 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r15 = i0.ɵɵnextContext(5);
    const _r0 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r0.invalid || ctx_r15.disabledControls || (!subItem_r11.comments || subItem_r11.comments && subItem_r11.comments.trim() === "") ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", _r0.invalid || ctx_r15.disabledControls || (!subItem_r11.comments || subItem_r11.comments && subItem_r11.comments.trim() === ""));
} }
function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 21);
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵelementStart(4, "textarea", 22, 18);
    i0.ɵɵlistener("ngModelChange", function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_2_ng_template_2_Template_textarea_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r23); const subItem_r11 = i0.ɵɵnextContext().$implicit; return subItem_r11.comments = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_2_ng_template_2_div_6_Template, 2, 2, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r13.isUserHasReviewerPermission ? "Enter your" : "Reviewer", " comments for ", subItem_r11.docName, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r13.isUserHasReviewerPermission || ctx_r13.disabledControls)("ngModel", subItem_r11.comments);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.isUserHasReviewerPermission);
} }
function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-accordionTab", 20);
    i0.ɵɵtemplate(2, ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_2_ng_template_2_Template, 7, 5, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r11 = ctx.$implicit;
    const subItemIndex_r12 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("header", subItem_r11.docName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModelGroup", subItemIndex_r12);
} }
function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "button", 24);
    i0.ɵɵlistener("click", function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r27); const item_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r25 = i0.ɵɵnextContext(3); return ctx_r25.handleSave(item_r5); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = i0.ɵɵnextContext(3);
    const _r0 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r0.invalid || ctx_r10.disabledControls || (!item_r5.comments || item_r5.comments && item_r5.comments.trim() === "") ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", _r0.invalid || ctx_r10.disabledControls || (!item_r5.comments || item_r5.comments && item_r5.comments.trim() === ""));
} }
function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h6", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_2_Template, 3, 2, "div", 11);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "h6");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 16);
    i0.ɵɵelementStart(7, "textarea", 17, 18);
    i0.ɵɵlistener("ngModelChange", function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_Template_textarea_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r31); const item_r5 = i0.ɵɵnextContext().$implicit; return item_r5.comments = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_div_9_Template, 2, 2, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r7.isUserHasReviewerPermission ? "Enter your review" : "Review", " for following sections under ", item_r5.titleSheetName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r5.docs);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Review Comments for ", item_r5.titleSheetName, " section");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", item_r5.comments)("disabled", !ctx_r7.isUserHasReviewerPermission || ctx_r7.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.isUserHasReviewerPermission);
} }
function ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-accordionTab", 12);
    i0.ɵɵtemplate(2, ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_ng_template_2_Template, 10, 7, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const itemIndex_r6 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("header", item_r5.titleSheetName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModelGroup", itemIndex_r6);
} }
function ReviewCommentsLibraryComponent_div_8_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ReviewCommentsLibraryComponent_div_8_ng_template_3_div_0_Template, 3, 2, "div", 11);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.listDocuments);
} }
function ReviewCommentsLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "p-accordion", 8);
    i0.ɵɵelementStart(2, "p-accordionTab", 9);
    i0.ɵɵtemplate(3, ReviewCommentsLibraryComponent_div_8_ng_template_3_Template, 1, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("multiple", true);
} }
class ReviewCommentsLibraryComponent extends BaseReviewCommentsLibraryService {
    constructor(store, apiService, toastr, authenticationService, guard) {
        super(store, apiService, toastr, authenticationService, guard);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.authenticationService = authenticationService;
        this.guard = guard;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        this.disabledControls = this.disabledControls;
        super.loadInit();
    }
    ngAfterViewInit() {
        this.reviewCommentForm = this.reviewCommentForm;
        super.ngAfterViewInit();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
ReviewCommentsLibraryComponent.ɵfac = function ReviewCommentsLibraryComponent_Factory(t) { return new (t || ReviewCommentsLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIReviewComments), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.AuthenticationService), i0.ɵɵdirectiveInject(i5.DirtyFormGuard)); };
ReviewCommentsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ReviewCommentsLibraryComponent, selectors: [["review-comments-library"]], viewQuery: function ReviewCommentsLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reviewCommentForm = _t.first);
    } }, inputs: { primaryData: "primaryData", disabledControls: "disabledControls" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 3, consts: [[1, "container-fluid", "add-comments", "pb-3"], ["reviewCommentForm", "ngForm"], [1, "row", "col-12", "p-0"], [1, "review-accordion"], ["class", "pl-2", 4, "ngIf"], ["class", "col-md-12", 4, "ngIf"], [1, "pl-2"], [1, "col-md-12"], ["collapseIcon", "pi pi-fw pi-chevron-up", "expandIcon", "pi pi-fw pi-chevron-down", 1, "review-accordions", 3, "multiple"], ["header", "All Documents List"], ["pTemplate", "content"], [4, "ngFor", "ngForOf"], [1, "pt-2", "pb-2", 3, "header"], ["pTemplate", "content", 3, "ngModelGroup"], [1, "pt-3"], [1, "col-md-12", "row", "pt-2", "pb-2"], [1, "row", "col-md-12", "input-disabled"], ["name", "comments", "type", "text", "rows", "3", "placeholder", "Enter Comments", "name", "comments", 1, "w-100", "mw-100", 3, "ngModel", "disabled", "ngModelChange"], ["comments", "ngModel"], ["class", "row col-md-12", 4, "ngIf"], [3, "header"], [1, "row", "col-md-12", "p-2"], ["name", "comments", "type", "text", "rows", "3", "placeholder", "Enter Comments", "name", "comments", 1, "w-100", "mw-100", 3, "disabled", "ngModel", "ngModelChange"], [1, "row", "col-md-12"], ["pButton", "", "type", "button", "label", "Save", "title", "Save", "icon", "pi pi-save", 3, "ngClass", "disabled", "click"]], template: function ReviewCommentsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "form", null, 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "h5");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵtemplate(7, ReviewCommentsLibraryComponent_span_7_Template, 2, 0, "span", 4);
        i0.ɵɵtemplate(8, ReviewCommentsLibraryComponent_div_8_Template, 4, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1("", ctx.isUserHasReviewerPermission ? "Add" : "View", " comments / notes for each document ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.listDocuments.length <= 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listDocuments.length > 0);
    } }, directives: [i6.ɵangular_packages_forms_forms_ba, i6.NgControlStatusGroup, i6.NgForm, i7.NgIf, i8.Accordion, i8.AccordionTab, i9.PrimeTemplate, i7.NgForOf, i6.NgModelGroup, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgModel, i10.ButtonDirective, i7.NgClass], styles: [".add-comments[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-size:16px;color:#8d8d8d;padding-bottom:10px}.review-accordion[_ngcontent-%COMP%]{border:1px solid #aaa;padding:10px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewCommentsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'review-comments-library',
                templateUrl: 'review-comments-library.component.html',
                styleUrls: ['review-comments-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIReviewComments }, { type: i3.ToastrService }, { type: i4.AuthenticationService }, { type: i5.DirtyFormGuard }]; }, { primaryData: [{
            type: Input
        }], disabledControls: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], reviewCommentForm: [{
            type: ViewChild,
            args: ['reviewCommentForm', { static: true }]
        }] }); })();

class ReviewCommentsLibraryModule {
}
ReviewCommentsLibraryModule.ɵfac = function ReviewCommentsLibraryModule_Factory(t) { return new (t || ReviewCommentsLibraryModule)(); };
ReviewCommentsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: ReviewCommentsLibraryModule });
ReviewCommentsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseReviewCommentsLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ReviewCommentsLibraryModule, { declarations: [ReviewCommentsLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule], exports: [ReviewCommentsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewCommentsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [ReviewCommentsLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule
                ],
                providers: [BaseReviewCommentsLibraryService],
                exports: [ReviewCommentsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of review-comments-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ReviewCommentsLibraryComponent, ReviewCommentsLibraryModule, ReviewCommentsLibraryService };
//# sourceMappingURL=review-comments-library.js.map
